import { useMutation } from '@tanstack/react-query';
import { payrollPreviewService } from '@/services/payroll/payrollPreviewService';
import type { EmployeePayrollData } from '@/services/payroll/types';

interface PreviewPayrollParams {
  startDate: string;
  endDate: string;
  selectedEmployees: EmployeePayrollData[];
}

export const usePayrollPreview = () => {
  return useMutation({
    mutationFn: ({ startDate, endDate, selectedEmployees }: PreviewPayrollParams) =>
      payrollPreviewService.generatePreview(startDate, endDate, selectedEmployees),
  });
};
